import { useParams } from 'react-router-dom';

const isDev = import.meta.env.VITE_NODE_ENV === 'DEV';

/**
 * Get domain from subdomain (prod) or URL param (dev)
 * - Prod: "soultos.dev.sala.gr" → "soultos"
 * - Dev: "localhost:9001/reserve/soultos" → "soultos" (from URL param)
 */
export function useDomain(): string | null {
  const { domain: paramDomain } = useParams<{ domain: string }>();

  if (isDev) {
    return paramDomain || null;
  }

  // Prod: extract from subdomain
  const hostname = window.location.hostname;
  const suffix = import.meta.env.VITE_PATH_SUBDOMAIN; // e.g., ".dev.sala.gr"
  if (suffix && hostname.endsWith(suffix)) {
    return hostname.slice(0, -suffix.length);
  }

  return null;
}

/**
 * Get the base path for reservation routes
 * - Dev: "/reserve/soultos"
 * - Prod: "/reserve"
 */
export function useReservePath(): string {
  const domain = useDomain();
  return isDev ? `/reserve/${domain}` : '/reserve';
}
